module.exports = "//d274d294w9cx2v.cloudfront.net/e5dfc4880fefa3759bb4948a9f3131c8d190b46c/images/photo-single.png";